/**
 * Monte gallery slide effect
 *
 * En desktop convierte la galeria principal en un carrusel horizontal:
 * todas las imagenes visibles estan lado a lado dentro de un overflow
 * hidden, y aplicamos translateX al <ul> segun el indice del item con
 * clase .is-active. Las imagenes ocultas por el filtro de color no
 * cuentan en el indice. La animacion es un slide suave izq/der.
 */

(function () {
  function setup(gallery) {
    const list = gallery.querySelector('.product__media-list');
    if (!list || list.dataset.monteSlideReady === 'true') return;
    list.dataset.monteSlideReady = 'true';

    const apply = () => {
      const allItems = Array.from(list.children).filter(
        (li) => li.tagName === 'LI'
      );
      const visible = allItems.filter(
        (li) =>
          !li.hasAttribute('data-monte-hidden') &&
          getComputedStyle(li).display !== 'none'
      );
      const active = list.querySelector('li.is-active');
      if (!active || !visible.length) return;
      const idx = visible.indexOf(active);
      if (idx < 0) return;
      list.style.transform = `translateX(${-idx * 100}%)`;
    };

    // Inicial.
    apply();

    // Observar cambios de clase is-active y de visibilidad.
    new MutationObserver(apply).observe(list, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'data-monte-hidden'],
    });

    // Re-aplicar al filtrar por color.
    document.addEventListener('monte:items-filtered', apply);
    // Re-aplicar al cambiar tamano de ventana.
    window.addEventListener('resize', apply);
  }

  function start() {
    // Solo en desktop. En mobile Dawn usa su propio slider con scroll-snap;
    // aplicar translateX rompe la navegacion de thumbs.
    if (window.matchMedia('(max-width: 749px)').matches) return;
    document.querySelectorAll('media-gallery').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
